import React, { useRef, useEffect } from "react";
import { Theme, alpha } from "@mui/material/styles";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: "relative",
    margin: "1em",
    height: "4px",
    "& div": {
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0
    }
  },
  progress: {
    background: "#174176",
    right: "100%"
  },
  background: {
    right: 0,
    background: alpha("#174176", 0.2)
  }
}));

interface ProgressBarProps {
  duration: number;
  position: number;
  progress?: any;
  background?: any;
  style?: { [key: string]: string };
}

export default function ProgressBar({
  duration,
  position,
  progress,
  background,
  style
}: ProgressBarProps) {
  const classes = useStyles();
  const progressBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = progressBarRef.current;
    if (el) {
      window.requestAnimationFrame(() => {
        // We set these values asynchronously so that the browser can recognize the change in the 'right' value.
        // Without this, the progress bar would instantly snap to the designated position.
        el.style.transition = `right ${duration}s linear`;
        el.style.right = `${String(100 - position)}%`;
      });
    }
  }, [duration, position]);

  return (
    <div className={classes.container} style={{ ...style }}>
      <div
        className={`${progress} ${classes.progress}`}
        ref={progressBarRef}
      ></div>
      <div className={`${background} ${classes.background}`}></div>
    </div>
  );
}
